"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLinkoutSuggestion = isLinkoutSuggestion;
/**
 * Determines if the suggestion is a LinkOutSuggestion
 *
 * @param {(LinkOutSuggestion | Suggestion)} suggestion
 * @returns {suggestion is LinkOutSuggestion}
 */
function isLinkoutSuggestion(suggestion) {
    if (!suggestion) {
        return false;
    }
    return suggestion.url !== undefined;
}
//# sourceMappingURL=isLinkoutSuggestion.js.map